import { CheckCircle2, Info } from "lucide-react";
import { ELIGIBILITY, DISCLAIMERS } from "@/data/content";
import { Reveal, SectionHeading } from "@/components/site/primitives";

export function Eligibility() {
  return (
    <section className="relative py-20 sm:py-28 bg-[#F7F5EF]" data-testid="eligibility-section">
      <div className="container-x">
        <SectionHeading overline="Eligibility" title="Who Can Apply?" align="center"
          subtitle="The School provides a structured pathway for a range of eligible candidates." />
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {ELIGIBILITY.map((e, i) => (
            <Reveal key={e} delay={(i % 3) * 0.06}>
              <div className="flex items-start gap-3 rounded-sm border border-slate-200 bg-white p-5 transition-all hover:border-[#0A1E4E] hover:shadow-md">
                <CheckCircle2 size={22} className="mt-0.5 shrink-0 text-[#C0202A]" />
                <span className="font-medium text-slate-800">{e}</span>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal>
          <div className="mt-8 flex items-center justify-center gap-2 text-sm text-slate-500">
            <Info size={16} /> {DISCLAIMERS.eligibility}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
